/**
 * T063: Prompt Detail Route
 * Route for viewing a single prompt
 */

import { createFileRoute } from '@tanstack/react-router'
import { PromptDetailPage } from '@/pages/prompts/prompt-detail'

export const Route = createFileRoute('/_authenticated/prompts/$id')({
  component: PromptDetailRoute,
})

function PromptDetailRoute() {
  const { id } = Route.useParams()
  return <PromptDetailPage promptId={id} />
}
